import Globais from "../components/Globais/Globais";
import Axios from 'axios';

import { codigoData, dataHoraAtualBrasileira} from '../services/datautils'

function cryptRC4(sText, sKey) {
  const baS = new Array(256);
  const baK = new Array(256);
  let lI = 0, lJ = 0, lIdx = 0;
  let crypto = '';

  // Inicialização dos vetores S e K
  for (lIdx = 0; lIdx < 256; lIdx++) {
    baS[lIdx] = lIdx;
    baK[lIdx] = sKey.charCodeAt(lIdx % sKey.length);
  }

  // Permutação de S com base em K
  for (lI = 0; lI < 256; lI++) {
    lJ = (lJ + baS[lI] + baK[lI]) % 256;
    [baS[lI], baS[lJ]] = [baS[lJ], baS[lI]]; // swap
  }

  lI = 0;
  lJ = 0;

  // Geração do fluxo criptografado
  for (lIdx = 0; lIdx < sText.length; lIdx++) {
    lI = (lI + 1) % 256;
    lJ = (lJ + baS[lI]) % 256;
    [baS[lI], baS[lJ]] = [baS[lJ], baS[lI]]; // swap

    const t = (baS[lI] + baS[lJ]) % 256;
    const k = baS[t];
    const charCode = sText.charCodeAt(lIdx);
    const xor = k ^ charCode;

    crypto += String.fromCharCode(xor);
  }

  return crypto;
}

function toHexDump(sText) {
  let resultado = '';
  for (let i = 0; i < sText.length; i++) {
    const hex = sText.charCodeAt(i).toString(16).padStart(2, '0');
    resultado += hex.toUpperCase();
  }
  return resultado;
}

function fromHexDump(sText) {
  let resultado = '';
  for (let i = 0; i < sText.length; i += 2) {
    const hex = sText.substr(i, 2);
    const charCode = parseInt(hex, 16);
    resultado += String.fromCharCode(charCode);
  }
  return resultado;
}

  // Função para montar a URL do S3 
  const getS3Url = (filename, tipo) => {
    if (!filename) return null;
    const bucket = Globais.bucketName;
    const region = Globais.regionName;

    let folder = '';

    if (tipo === 'Documento') {
      folder = Globais.folderDocName;

    } else {
      folder = Globais.folderName;

    }
    return `https://${bucket}.s3.${region}.amazonaws.com/${folder}/${filename}`;
  };

  async function codificaSenha (texto) {
  //const sha256(message) {
    // console.log("Texto para Codificar: ", message);

    // encode as UTF-8
    const msgBuffer = new TextEncoder().encode(texto);

    // hash the message
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    
    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    // convert bytes to hex string
    const hashHex = hashArray.map(b => ('00' + b.toString(16)).slice(-2)).join('');

    // console.log("Hash final: ", hashHex);
    return hashHex;
  }

  async function defineCodigoFrontend(tabela, campo, condicao, orderBy){
    const url = Globais.url_consulta
    const campos = `max(${campo})+1 as cod`;

    try {
      const response = await Axios.post(url,
        { 
          tabela: tabela,
          campos: campos,
          condicao: condicao,
          orderBy: orderBy
        }
      );
      
      if (response.data.statusCode === 200) {
        const codigo = JSON.parse(response.data.body);

        if (codigo.length === 0){
          toast.error('Erro (Retorno 0)!');
  
        } else {
            return codigo[0].cod;
        }

      } else {
        return 0;
      }
    } catch (err) {
      console.log("Erro GenerateCode: ", err);
      return 0;
    }
  }

  async function defineCodigoOrdem () {
    const dataCodigo = codigoData(dataHoraAtualBrasileira());
    return dataCodigo + '00';
  }

  const toBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload  = () => {
      // Remove prefixo "data:image/jpeg;base64," — envia só a string pura
      const base64String = reader.result.split(",")[1];
      resolve(base64String);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });



export {
  cryptRC4, 
  toHexDump,
  fromHexDump,
  getS3Url,
  codificaSenha,
  defineCodigoFrontend,
  defineCodigoOrdem,
  toBase64,
}